interface BatchInputFormProps {
    batchInput: string
    setBatchInput: (value: string) => void
    isProcessing: boolean
    processingType: "last_occurrence" | "all_occurrences"
    setProcessingType: (type: "last_occurrence" | "all_occurrences") => void
    getInputLineCount: () => number
}

export const BatchInputForm = ({
    batchInput,
    setBatchInput,
    isProcessing,
    processingType,
    setProcessingType,
    getInputLineCount
}: BatchInputFormProps) => {
    console.log("BatchInputForm - processingType:", processingType)

    const handleProcessingTypeChange = (value: string) => {
        console.log("Changing processingType from", processingType, "to", value)
        setProcessingType(value as "last_occurrence" | "all_occurrences")
    }

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
                📋 Dados para Processamento
            </h2>
            <p className="text-gray-600 mb-4">
                Cole ou digite seus dados no formato simples: <br />
                <code className="bg-blue-50 border border-blue-200 px-3 py-1 rounded text-blue-800 font-medium">
                    NumeroNota,Serie
                </code>
                <span className="text-sm text-gray-500 block mt-1">
                    Uma linha por rastreamento
                </span>
            </p>
            <textarea
                value={batchInput}
                onChange={(e) => setBatchInput(e.target.value)}
                placeholder="Exemplo:&#10;123456,04&#10;789012,01"
                className="w-full h-64 p-4 border border-gray-300 rounded-lg text-sm font-mono resize-none"
                disabled={isProcessing}
            />
            <p className="text-sm text-gray-500 mt-2">
                Total de linhas: {getInputLineCount()}
            </p>

            <div className="mt-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                    Tipo de Relatório:
                </h3>
                <div className="space-y-3">
                    <label className="flex items-start cursor-pointer">
                        <input
                            type="radio"
                            name="processingType"
                            value="last_occurrence"
                            checked={processingType === "last_occurrence"}
                            onChange={(e) =>
                                handleProcessingTypeChange(e.target.value)
                            }
                            className="mt-1 mr-3"
                            disabled={isProcessing}
                        />
                        <div>
                            <span className="font-semibold text-gray-800">
                                Última Ocorrência
                            </span>
                            <p className="text-sm text-gray-600">
                                Uma linha por consulta com apenas a última
                                ocorrência de rastreamento
                            </p>
                        </div>
                    </label>
                    <label className="flex items-start cursor-pointer">
                        <input
                            type="radio"
                            name="processingType"
                            value="all_occurrences"
                            checked={processingType === "all_occurrences"}
                            onChange={(e) =>
                                handleProcessingTypeChange(e.target.value)
                            }
                            className="mt-1 mr-3"
                            disabled={isProcessing}
                        />
                        <div>
                            <span className="font-semibold text-gray-800">
                                Todas as Ocorrências
                            </span>
                            <p className="text-sm text-gray-600">
                                Múltiplas linhas por consulta com todas as
                                ocorrências de rastreamento
                            </p>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    )
}
